import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { Navigate, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import { AuthContext } from "../../context/AuthContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Menu from "./Menu";
import Spinner from "./Spinner";

export default function EvaluacionAuditivaPeriodica() {
  const navigate = useNavigate();
  const toast = useRef(null);
  const [dialogPacientes, setDialogPacientes] = useState(false);
  const [dialogEvoluciones, setDialogEvoluciones] = useState(false);
  const [dialogEvolucion, setDialogEvolucion] = useState(false);
  const [dialogUltimasEvaluacionesAuditivas, setDialogUltimasEvaluacionesAuditivas] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [selectedRowPacienteDialog, setSelectedRowPacienteDialog] = useState(null);
  const [selectedRowEvolucionAuditiva, setSelectedRowEvolucionAuditiva] = useState(null);
  const [datosAuditiva, setDatosAuditiva] = useState({});
  const [modoEvolucion, setModoEvolucion] = useState("agregar");

  const { state, usuarioAutenticado } = useContext(AuthContext);
  const {
    statusAcceso,
    pacientes,
    selectedRowPaciente,
    geriatricoElegido,
    obrasSociales,
    obrasSocialesMedicas,
    evolucionesAuditivas,
    ultimasEvaluacionesAuditivas,
    obtenerAcceso,
    obtenerPacientes,
    obtenerObrasSocialesPacientes,
    obtenerObrasSocialesMedicasPacientes,
    setSelectedRowPaciente,
    obtenerEvolucionesAuditivas,
    obtenerUltimasEvaluacionesAuditivas,
    agregarEvolucionAuditiva,
    setGeriatricoElegido,
  } = useContext(ServiciosContext);

  useEffect(() => {
    usuarioAutenticado();
    setGeriatricoElegido({
      id: Number(localStorage.getItem("geriatricoElegidoId")),
      nombre: localStorage.getItem("geriatricoElegidoNombre"),
    });
    obtenerPacientes({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
    obtenerObrasSocialesPacientes({ todos: false });
    obtenerObrasSocialesMedicasPacientes({ todos: false });
    // Las funciones del contexto no tienen referencias estables.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "Evaluaciones",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.usuario]);

  const todasEvaluacionesAuditivas = () => {
    obtenerUltimasEvaluacionesAuditivas({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
    setDialogUltimasEvaluacionesAuditivas(true);
  };

  const abrirPacientes = () => {
    setSelectedRowPacienteDialog(null);
    setDialogPacientes(true);
  };

  const cargarDatosAuditivos = (pacienteId) => {
    obtenerEvolucionesAuditivas({ pacienteId });
  };

  const aceptarPaciente = () => {
    if (!selectedRowPacienteDialog) {
      toast.current.show({
        severity: "info",
        summary: "Evaluación auditiva",
        detail: "Debe seleccionar un residente.",
        life: 3000,
      });
      return;
    }

    setSelectedRowPaciente(selectedRowPacienteDialog);
    setSelectedRowEvolucionAuditiva(null);
    setDatosAuditiva({});
    cargarDatosAuditivos(selectedRowPacienteDialog.id);
    setDialogPacientes(false);
    setDialogEvoluciones(true);
  };

  const abrirAgregarEvolucion = () => {
    setModoEvolucion("agregar");
    setSelectedRowEvolucionAuditiva(null);
    setDatosAuditiva({});
    setDialogEvolucion(true);
  };

  const abrirVerEvolucion = () => {
    if (!selectedRowEvolucionAuditiva) {
      toast.current.show({
        severity: "info",
        summary: "Evaluación auditiva",
        detail: "Debe seleccionar una evaluación.",
        life: 3000,
      });
      return;
    }

    setModoEvolucion("ver");
    setDatosAuditiva({
      tieneProblemasAudicion: selectedRowEvolucionAuditiva.tieneProblemasAudicion,
      gravedadAudicion: selectedRowEvolucionAuditiva.gravedadAudicion,
      usaAudifonos: selectedRowEvolucionAuditiva.usaAudifonos,
      evolucion: selectedRowEvolucionAuditiva.evolucion,
    });
    setDialogEvolucion(true);
  };

  const guardarEvolucion = async () => {
    if (!selectedRowPaciente) {
      toast.current.show({
        severity: "info",
        summary: "Evaluación auditiva",
        detail: "Debe seleccionar un residente.",
        life: 3000,
      });
      return;
    }

    const tieneProblemas =
      datosAuditiva.tieneProblemasAudicion === true || datosAuditiva.tieneProblemasAudicion === "true";

    if (
      datosAuditiva.tieneProblemasAudicion === undefined ||
      datosAuditiva.usaAudifonos === undefined ||
      (tieneProblemas && !datosAuditiva.gravedadAudicion)
    ) {
      toast.current.show({
        severity: "info",
        summary: "Evaluación auditiva",
        detail: "Debe completar todos los campos.",
        life: 3000,
      });
      return;
    }

    const guardado = await agregarEvolucionAuditiva({
      pacienteId: selectedRowPaciente.id,
      tieneProblemasAudicion: datosAuditiva.tieneProblemasAudicion,
      gravedadAudicion: tieneProblemas ? datosAuditiva.gravedadAudicion : null,
      usaAudifonos: datosAuditiva.usaAudifonos,
      evolucion: datosAuditiva.evolucion,
      usuario: state.usuario,
    });

    if (guardado) {
      setDatosAuditiva({});
      setDialogEvolucion(false);
      obtenerEvolucionesAuditivas({ pacienteId: selectedRowPaciente.id });
    }
  };

  const formatDate = (fecha) => {
    if (!fecha) return "";
    const date = fecha.slice(0, 10).split("-");
    if (date.length !== 3) return fecha;
    return [date[2], date[1], date[0]].join("/");
  };

  const siNo = (valor) => (valor === true || valor === "true" ? "SI" : "NO");

  const headerPacientes = (
    <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
      <Typography variant="h6">Seleccionar residente</Typography>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Buscar"
        />
      </span>
    </div>
  );

  const headerEvoluciones = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <Button
          icon="pi pi-plus"
          tooltip="Agregar"
          className="p-button-rounded p-button-help"
          onClick={abrirAgregarEvolucion}
        />
        <Button
          icon="pi pi-pencil"
          tooltip="Ver"
          className="p-button-rounded p-button-success"
          style={{ marginLeft: "1em" }}
          onClick={abrirVerEvolucion}
        />
      </div>
    </Fragment>
  );

  function getEdad(dateString) {
    let hoy = new Date();
    let fechaNacimiento = new Date(dateString);
    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    let diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
    if (
      diferenciaMeses < 0 ||
      (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
    ) {
      edad--;
    }
    return edad;
  }

  const imprimirUltimasEvaluacionesAuditivas = () => {
    const doc = new jsPDF();
    const sumarCampos = (objeto, campos) =>
      objeto
        ? campos.reduce(
            (total, campo) => total + Number(objeto[campo] || 0),
            0,
          )
        : "";
    const obtenerNombreObraSocial = (opciones, id) => {
      const opcion = opciones && opciones.find((item) => item.id === id);
      return opcion ? opcion.label : "";
    };
    const escribirLista = (items, row) => {
      doc.setFontSize(9);
      (items || []).forEach((item) => {
        const lineas = doc.splitTextToSize(`-${item}`, 180);
        doc.text(lineas, 10, row);
        row += lineas.length * 5;
      });
      doc.setFontSize(10);
      return row;
    };
    const escribirTexto = (texto, row) => {
      const lineas = doc.splitTextToSize(texto || "", 180);
      if (lineas.length > 0) {
        doc.text(lineas, 10, row);
      }
      return row + lineas.length * 5;
    };

    (ultimasEvaluacionesAuditivas || []).forEach((item, index) => {
      if (index > 0) {
        doc.addPage();
      }

      doc.setFontSize(12);
      doc.setFont("Times", "bolditalic");
      doc.text((geriatricoElegido && geriatricoElegido.nombre) || "", 15, 8);
      doc.rect(10, 12, 190, 30);
      doc.setFontSize(14);
      doc.setFont("Times", "bolditalic");
      doc.text("EVALUACION AUDITIVA PERIODICA", 45, 20);
      doc.setFont("Times", "normal");
      doc.setFontSize(10);

      let row = 25;
      doc.text(`Paciente: ${item.nombre || ""}`, 12, row);
      doc.text(`D.N.I.: ${item.numeroDocumento || ""}`, 130, row);
      row += 5;
      doc.text(
        `Fecha Nacimiento: ${item.fechaNacimiento ? formatDate(item.fechaNacimiento) : ""}`,
        12,
        row,
      );
      doc.text(
        `Edad: ${item.fechaNacimiento ? getEdad(item.fechaNacimiento) : ""}`,
        130,
        row,
      );
      row += 5;
      doc.text(
        `Fecha de Ingreso a la Institucion: ${item.fechaIngreso ? formatDate(item.fechaIngreso) : ""}`,
        12,
        row,
      );
      doc.text(
        `Obra Social Contrato: ${obtenerNombreObraSocial(
          obrasSociales,
          item.obraSocialContratoId,
        )}`,
        130,
        row,
      );
      row += 5;
      doc.text(
        `Obra Social Medica: ${obtenerNombreObraSocial(
          obrasSocialesMedicas,
          item.obraSocialId,
        )}`,
        12,
        row,
      );
      doc.text(`Nro Obra Social: ${item.numeroObraSocial || ""}`, 130, row);
      row += 10;

      doc.text(`Fecha: ${item.fecha ? formatDate(item.fecha) : ""}`, 12, row);
      row += 10;

      doc.text("DIAGNOSTICOS DE INGRESO: ", 10, row);
      row += 5;
      row = escribirLista(item.diagnosticos, row);
      row += 5;

      doc.text("EVALUACION DE INGRESO: ", 10, row);
      row += 10;
      doc.text(
        `BARTHEL: ${sumarCampos(item.barthel, [
          "comer",
          "lavarse",
          "vestirse",
          "arreglarse",
          "deposiciones",
          "miccion",
          "retrete",
          "trasladarse",
          "deambular",
          "escalones",
        ])}`,
        10,
        row,
      );
      doc.text(
        `LAWTON Y BRODY: ${sumarCampos(item.lawtonBrody, [
          "telefonoResultado",
          "comprasResultado",
          "comidaResultado",
          "casaResultado",
          "ropaResultado",
          "transporteResultado",
          "medicacionResultado",
          "economicoResultado",
        ])}`,
        60,
        row,
      );
      doc.text(
        `TINETTI: ${sumarCampos(item.tinetti, [
          "equilibrioSentado",
          "levantarse",
          "intentoLevantarse",
          "equilibrioSegundos",
          "equilibrioProlongado",
          "rombergSensibilizado",
          "romberg",
          "girar",
          "girar2",
          "sentarse",
        ])}`,
        110,
        row,
      );
      doc.text(
        `NORTON: ${sumarCampos(item.norton, [
          "estadoFisico",
          "estadoMental",
          "actividad",
          "movilidad",
          "incontinencia",
        ])}`,
        150,
        row,
      );
      row += 5;

      const totalFragilidad = item.fragilidad
        ? Array.from({ length: 27 }, (_, indice) => indice + 1).reduce(
            (total, numero) =>
              total +
              Number(
                item.fragilidad[`pregunta${numero}`]
                  ? item.fragilidad[`pregunta${numero}Value`] || 0
                  : 0,
              ),
            0,
          )
        : "";
      const observacionesFragilidad =
        item.fragilidad && item.fragilidad.observaciones
          ? ` - ${item.fragilidad.observaciones}`
          : "";
      row = escribirTexto(
        `MARCADORES DE FRAGILIDAD: ${totalFragilidad}${observacionesFragilidad}`,
        row,
      );
      row += 5;

      doc.text(
        "_____________________________________________________________________________________________",
        10,
        row,
      );
      row += 10;

      doc.text("MEDICACION: ", 10, row);
      row += 5;
      row = escribirLista(item.medicaciones, row);
      row += 5;

      doc.text("EVALUACION AUDITIVA: ", 10, row);
      row += 8;
      if (item.evolucionAuditivaId) {
        doc.text(`Tiene problemas de audición: ${siNo(item.tieneProblemasAudicion)}`, 10, row);
        row += 8;
        doc.text(`Gravedad: ${item.gravedadAudicion || "-"}`, 10, row);
        row += 8;
        doc.text(`Usa audífonos: ${siNo(item.usaAudifonos)}`, 10, row);
        row += 8;
        if (item.evolucion) {
          row = escribirTexto(`Evolución: ${item.evolucion}`, row);
        }
      } else {
        row = escribirTexto("Sin evaluaciones auditivas.", row);
      }
      doc.text(
        "_____________________________________________________________________________________________",
        10,
        row,
      );

      doc.text("FIRMA Y SELLO", 90, 290);
    });

    window.open(doc.output("bloburl"));
  };

  const footerPacientes = (
    <div>
      <ButtonMui
        onClick={aceptarPaciente}
        color="primary"
        type="button"
        fullWidth
        variant="contained"
        startIcon={<CheckIcon />}
      >
        Aceptar
      </ButtonMui>
      <ButtonMui
        onClick={() => setDialogPacientes(false)}
        color="secondary"
        type="button"
        fullWidth
        variant="contained"
        startIcon={<CloseIcon />}
        autoFocus
      >
        Cancelar
      </ButtonMui>
    </div>
  );

  const footerEvolucion = (
    <div>
      {modoEvolucion === "agregar" ? (
        <ButtonMui
          onClick={guardarEvolucion}
          color="primary"
          type="button"
          variant="contained"
        >
          Aceptar
        </ButtonMui>
      ) : null}
      <ButtonMui
        onClick={() => setDialogEvolucion(false)}
        color="secondary"
        type="button"
        variant="contained"
        style={{ marginLeft: "0.75rem" }}
      >
        Cancelar
      </ButtonMui>
    </div>
  );
  const accesoDenegado = () => <Navigate to="/" replace />;

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Grid container spacing={2} style={{ padding: "1rem", marginTop: "3vw" }}>
          <Grid item xs={12}>
            <Button
              icon="pi pi-search"
              tooltip="Residentes"
              className="p-button-rounded p-button-help"
              onClick={abrirPacientes}
            />
            <Button
              icon="pi pi-chart-bar"
              tooltip="Evaluaciones Pacientes"
              className="p-button-rounded p-button-secondary"
              style={{ marginLeft: "1rem" }}
              onClick={todasEvaluacionesAuditivas}
            />
            <Button
              icon="pi pi-times"
              tooltip="Cerrar"
              className="p-button-rounded p-button-primary"
              style={{ marginLeft: "1rem" }}
              onClick={() => navigate("/")}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5">Evaluación Auditiva Periódica</Typography>
            <Typography variant="body1">
              Seleccione un residente para consultar su evaluación auditiva.
            </Typography>
          </Grid>
        </Grid>
      ) : null}

      <Dialog
        visible={dialogPacientes}
        header={headerPacientes}
        footer={footerPacientes}
        onHide={() => setDialogPacientes(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "75vw" }}
        position="top"
      >
        <DataTable
          value={pacientes || []}
          selection={selectedRowPacienteDialog}
          onSelectionChange={(e) => setSelectedRowPacienteDialog(e.value)}
          selectionMode="single"
          dataKey="id"
          globalFilter={globalFilter}
          emptyMessage="No hay residentes."
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          responsiveLayout="scroll"
          className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
        >
          <Column field="id" header="ID" sortable />
          <Column field="nombre" header="Apellido y nombre" sortable />
          <Column field="numeroDocumento" header="Documento" sortable />
          <Column field="domicilio" header="Domicilio" sortable />
          <Column field="activo" header="Activo" body={(row) => (row.activo ? "Sí" : "No")} sortable />
        </DataTable>
      </Dialog>

      <Dialog
        header={
          selectedRowPaciente ? <Tag value={`Evaluaciones auditivas de ${selectedRowPaciente.nombre}`} /> : null
        }
        visible={dialogEvoluciones}
        closable={true}
        onHide={() => setDialogEvoluciones(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "75vw", paddingBottom: "0" }}
        position="top"
      >
        <DataTable
          value={evolucionesAuditivas || []}
          selection={selectedRowEvolucionAuditiva}
          onSelectionChange={(e) => setSelectedRowEvolucionAuditiva(e.value)}
          selectionMode="single"
          dataKey="id"
          header={headerEvoluciones}
          className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
          emptyMessage="No hay evaluaciones auditivas."
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          responsiveLayout="scroll"
        >
          <Column field="fecha" header="Fecha" body={(row) => formatDate(row.fecha)} sortable />
          <Column field="usuario" header="Usuario" sortable />
          <Column
            field="tieneProblemasAudicion"
            header="Tiene problemas de audición"
            body={(row) => siNo(row.tieneProblemasAudicion)}
            sortable
          />
          <Column
            field="gravedadAudicion"
            header="Gravedad"
            body={(row) => row.gravedadAudicion || "-"}
            sortable
          />
          <Column field="usaAudifonos" header="Usa audífonos" body={(row) => siNo(row.usaAudifonos)} sortable />
          <Column field="evolucion" header="Evolución" sortable />
        </DataTable>
      </Dialog>

      <Dialog
        header={modoEvolucion === "agregar" ? "Agregar evaluación auditiva" : "Ver evaluación auditiva"}
        visible={dialogEvolucion}
        maximized={true}
        closable={true}
        footer={footerEvolucion}
        onHide={() => setDialogEvolucion(false)}
      >
        <Grid container spacing={2} style={{ paddingTop: "0.5rem" }}>
          <Grid item xs={12} md={12} style={{ marginTop: "-1vw" }}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={
                  datosAuditiva.tieneProblemasAudicion !== undefined
                    ? datosAuditiva.tieneProblemasAudicion
                    : null
                }
                onChange={(e) =>
                  setDatosAuditiva({
                    ...datosAuditiva,
                    tieneProblemasAudicion: e.target.value,
                    gravedadAudicion:
                      e.target.value === "true" || e.target.value === true
                        ? datosAuditiva.gravedadAudicion
                        : null,
                  })
                }
              >
                <FormLabel
                  id="tieneProblemasAudicion"
                  style={{
                    fontWeight: "bold",
                    fontSize: "large",
                    marginRight: "1vw",
                    marginTop: ".5vw",
                  }}
                >
                  Tiene problemas de audición
                </FormLabel>

                <FormControlLabel value={true} control={<Radio />} label="SI" disabled={modoEvolucion !== "agregar"} />
                <FormControlLabel value={false} control={<Radio />} label="NO" disabled={modoEvolucion !== "agregar"} />
              </RadioGroup>
            </FormControl>
          </Grid>

          {datosAuditiva.tieneProblemasAudicion === true ||
          datosAuditiva.tieneProblemasAudicion === "true" ? (
            <Grid item xs={12} md={12} style={{ marginTop: "-1vw" }}>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={datosAuditiva.gravedadAudicion || null}
                  onChange={(e) =>
                    setDatosAuditiva({ ...datosAuditiva, gravedadAudicion: e.target.value })
                  }
                >
                  <FormLabel
                    id="gravedadAudicion"
                    style={{
                      fontWeight: "bold",
                      fontSize: "large",
                      marginRight: "1vw",
                      marginTop: ".5vw",
                    }}
                  >
                    Gravedad
                  </FormLabel>

                  <FormControlLabel
                    value="Leve"
                    control={<Radio />}
                    label="Leve"
                    disabled={modoEvolucion !== "agregar"}
                  />
                  <FormControlLabel
                    value="Moderado"
                    control={<Radio />}
                    label="Moderado"
                    disabled={modoEvolucion !== "agregar"}
                  />
                  <FormControlLabel
                    value="Grave"
                    control={<Radio />}
                    label="Grave"
                    disabled={modoEvolucion !== "agregar"}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          ) : null}

          <Grid item xs={12} md={12} style={{ marginTop: "-1vw" }}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={datosAuditiva.usaAudifonos !== undefined ? datosAuditiva.usaAudifonos : null}
                onChange={(e) => setDatosAuditiva({ ...datosAuditiva, usaAudifonos: e.target.value })}
              >
                <FormLabel
                  id="usaAudifonos"
                  style={{
                    fontWeight: "bold",
                    fontSize: "large",
                    marginRight: "1vw",
                    marginTop: ".5vw",
                  }}
                >
                  Usa audífonos
                </FormLabel>

                <FormControlLabel value={true} control={<Radio />} label="SI" disabled={modoEvolucion !== "agregar"} />
                <FormControlLabel value={false} control={<Radio />} label="NO" disabled={modoEvolucion !== "agregar"} />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={4}
              label="Evolución"
              value={datosAuditiva.evolucion || ""}
              onChange={(e) => setDatosAuditiva({ ...datosAuditiva, evolucion: e.target.value })}
              disabled={modoEvolucion !== "agregar"}
            />
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        header={
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Tag value="Ultima evaluacion auditiva de pacientes activos" />
            <Button
              icon="pi pi-print"
              tooltip="Imprimir listado"
              className="p-button-rounded p-button-help"
              onClick={imprimirUltimasEvaluacionesAuditivas}
              disabled={!ultimasEvaluacionesAuditivas || ultimasEvaluacionesAuditivas.length === 0}
            />
          </div>
        }
        visible={dialogUltimasEvaluacionesAuditivas}
        closable={true}
        onHide={() => setDialogUltimasEvaluacionesAuditivas(false)}
        breakpoints={{ "960px": "95vw" }}
        style={{ width: "90vw", paddingBottom: "0" }}
        position="top"
      >
        <div style={{ width: "100%" }}>
          {ultimasEvaluacionesAuditivas && ultimasEvaluacionesAuditivas.length > 0 ? (
            ultimasEvaluacionesAuditivas.map((item) => (
              <div
                key={item.pacienteId}
                style={{
                  padding: "1rem 0",
                  borderBottom: "1px solid #d9d9d9",
                }}
              >
                <Typography variant="h6" style={{ marginBottom: "0.5rem" }}>
                  {item.nombre} - DNI {item.numeroDocumento}
                </Typography>
                {item.evolucionAuditivaId ? (
                  <Fragment>
                    <Typography variant="body2" style={{ marginBottom: "0.5rem" }}>
                      Fecha: {formatDate(item.fecha)} | Usuario: {item.usuario || "-"}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Tiene problemas de audición:</strong> {siNo(item.tieneProblemasAudicion)} |{" "}
                      <strong>Gravedad:</strong> {item.gravedadAudicion || "-"} |{" "}
                      <strong>Usa audífonos:</strong> {siNo(item.usaAudifonos)}
                    </Typography>
                    {item.evolucion ? (
                      <Typography variant="body1">
                        <strong>Evolución:</strong> {item.evolucion}
                      </Typography>
                    ) : null}
                  </Fragment>
                ) : (
                  <Typography variant="body2">Sin evaluaciones auditivas.</Typography>
                )}
              </div>
            ))
          ) : (
            <Typography variant="body1">No hay pacientes activos.</Typography>
          )}
        </div>
      </Dialog>
    </Fragment>
  );
}
